import _pickBy from 'lodash/pickBy';
import _keys from 'lodash/keys';
import _pick from 'lodash/pick';
import _without from 'lodash/without';
import _mapValues from 'lodash/mapValues';
import _union from 'lodash/union';
import {
  REQUEST_MARKETPLACE_VENDORS,
  RECEIVE_MARKETPLACE_VENDORS,
  NO_MARKETPLACE_VENDORS_EXIST,
  VENDOR_REPORTS,
  NO_VENDOR_REPORTS,
  FILTER_MARKETPLACE_VENDORS_DATA,
  SELECT_MARKETPLACE_VENDOR,
  SELECT_ALL_MARKETPLACE_VENDORS,
  DESELECT_ALL_MARKETPLACE_VENDORS,
  DELETE_SELECTED,
  EMAIL_SELECTED,
  SORT_VENDORS,
} from './types';

const initialState = {
  pending: false,
  chunks: {},
  items: [],
  filteredChunks: {},
  filter: '',
  error: null,
  selected: [],
  vendorDialogOpen: false,
  selectAll: false,
  selectedVendors: {},
  approvedVendors: [],
  rejectedVendors: [],
  pendingVendors: [],
  vendorReports: [],
};

const filterChunks = (chunks, filterHolder = {}) => {
  let filteredChunks = chunks;
  const searchText = filterHolder.searchText.replace(/[^a-zA-Z0-9 ]/g, '');
  const vendorStatusFilter = filterHolder.vendorStatusFilter;
  filteredChunks = _pickBy(filteredChunks, chunk => {
    if (vendorStatusFilter === 'approved') return chunk.vendorApprovalStatus;
    if (vendorStatusFilter === 'rejected')
      return chunk.vendorApprovalStatus === false;
    if (vendorStatusFilter === 'pending')
      return chunk.vendorApprovalStatus === undefined;
    return true;
  });
  if (searchText !== '') {
    filteredChunks = _pickBy(filteredChunks, chunk => {
      const rgx = new RegExp(`(${searchText})`, 'gi');
      const fullName = `${chunk.firstName} ${chunk.lastName}`;
      return (
        rgx.test(chunk.email) ||
        rgx.test(chunk.firstName) ||
        rgx.test(chunk.lastName) ||
        rgx.test(fullName)
      );
      // return rgx.test(chunk.email);
    });
  }
  const items = Object.keys(filteredChunks);

  return { filteredChunks, items };
};

const sortItems = (filteredChunks, sortBy, order) =>
  _keys(filteredChunks).sort((a, b) => {
    let keyA = filteredChunks[a][sortBy];
    let keyB = filteredChunks[b][sortBy];
    if (sortBy === 'date') {
      keyA = new Date(filteredChunks[a][sortBy]);
      keyB = new Date(filteredChunks[b][sortBy]);
    }
    if (order === 'desc') {
      if (keyA > keyB) return -1;
      if (keyA < keyB) return 1;
    } else if (order === 'asc') {
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
    }
    return 0;
  });

const vendors = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MARKETPLACE_VENDORS:
      return {
        ...state,
        pending: true,
        error: null,
      };

    case RECEIVE_MARKETPLACE_VENDORS: {
      const filteredChunks = {};
      if (Object.keys(state.filteredChunks).length) {
        Object.keys(action.payload.vendors).forEach(key => {
          filteredChunks[key] = action.payload.vendors[key];
          filteredChunks[key].selected =
            state.filteredChunks[key] && state.filteredChunks[key].selected
              ? state.filteredChunks[key].selected
              : false;
        });
      }
      return {
        ...state,
        chunks: action.payload.vendors,

        filteredChunks: Object.keys(filteredChunks).length
          ? filteredChunks
          : action.payload.vendors,
        items: _keys(action.payload.vendors),
        pending: false,
        error: null,
      };
    }

    case RECEIVE_MARKETPLACE_VENDORS: {
      const filteredChunks = {};
      if (Object.keys(state.filteredChunks).length) {
        Object.keys(action.payload.vendors).forEach(key => {
          filteredChunks[key] = action.payload.vendors[key];
          filteredChunks[key].selected =
            state.filteredChunks[key] && state.filteredChunks[key].selected
              ? state.filteredChunks[key].selected
              : false;
        });
      }
      return {
        ...state,
        chunks: action.payload.vendors,
        filteredChunks: Object.keys(filteredChunks).length
          ? filteredChunks
          : action.payload.vendors,
        items: _keys(action.payload.vendors),
        pending: false,
        error: null,
      };
    }

    case NO_MARKETPLACE_VENDORS_EXIST:
      return {
        ...state,
        pending: false,
        chunks: {},
        items: [],
        filteredChunks: {},
        selected: [],
        selectAll: false,
      };

    case VENDOR_REPORTS:
      return {
        ...state,
        vendorReports: action.payload,
      };

    case NO_VENDOR_REPORTS:
      return {
        ...state,
        vendorReports: [],
      };

    case FILTER_MARKETPLACE_VENDORS_DATA:
      return {
        ...state,
        ...filterChunks(state.chunks, action.payload),
        filter: action.payload,
      };

    case SELECT_MARKETPLACE_VENDOR: {
      const prevState = state.filteredChunks[action.key].selected;

      return {
        ...state,
        filteredChunks: {
          ...state.filteredChunks,
          [action.key]: {
            ...state.filteredChunks[action.key],
            selected: !prevState,
          },
        },
        selected:
          prevState === true
            ? _without(state.selected, action.key)
            : state.selected.concat(action.key),
      };
    }

    case SELECT_ALL_MARKETPLACE_VENDORS: {
      const filteredChunks = _pick(state.chunks, state.items);
      const selectedChunks = _mapValues(filteredChunks, chunk => ({
        ...chunk,
        selected: true,
      }));
      const selected = _union(state.selected, _keys(filteredChunks));

      return {
        ...state,
        filteredChunks: {
          ...state.chunks,
          ...selectedChunks,
        },
        selected,
        selectAll: true,
      };
    }

    case DESELECT_ALL_MARKETPLACE_VENDORS:
      return {
        ...state,
        filteredChunks: _mapValues(state.chunks, chunk => ({
          ...chunk,
          selected: false,
        })),
        selected: [],
        selectAll: false,
      };

    case DELETE_SELECTED:
    case EMAIL_SELECTED:
      return {
        ...state,
      };

    case SORT_VENDORS:
      return {
        ...state,
        order: state.order === 'desc' ? 'asc' : 'desc',
        items: sortItems(
          state.filteredChunks,
          action.column.id,
          state.order === 'desc' ? 'asc' : 'desc',
        ),
        colSorted: action.column.id,
      };

    default:
      return state;
  }
};

export default vendors;
